/** @jsxRuntime classic */
/** @jsx jsx */
import { LinkProvider } from '@bottlebooks/gatsby-theme-event/src/useLink';
import { jsx } from 'theme-ui';

export default function PreviewLinkProvider({ eventId, children }) {
  return (
    <LinkProvider
      value={{
        base: `p/events/${eventId}`,
        products: 'products',
        exhibitors: 'exhibitors',
        producers: 'producers',
        home: '',
        productLists: 'lists',
      }}
    >
      {children}
    </LinkProvider>
  );
}
